import { j as a } from "./jsx-runtime.DGlMoOmv.js";
import { P as h, T as b, R as v, C as j, F as N, a as x, D as f, O as p, b as u } from "./X24.CNnx-_EL.js";
import { c } from "./index.C4-GUKyp.js";
import * as o from "react";
import { B as D } from "./Button.Ccj-dDdM.js";
import { c as l } from "./index.CxSWpsOB.js";
const I = (t) => /* @__PURE__ */ a.jsx(v, { ...t }), y = o.createContext({}), J = b, C = h, R = ({
  headerAlignment: t,
  ...e
}) => /* @__PURE__ */ a.jsx(j, { asChild: !0, ...e, children: /* @__PURE__ */ a.jsxs(D, { variant: "text-only", className: l({
  "tw-absolute tw-right-24 sm:tw-right-32 tw-top-24 sm:tw-top-32": t === "center",
  "tw-ml-64": t !== "center"
}), children: [
  /* @__PURE__ */ a.jsx(N, {}),
  /* @__PURE__ */ a.jsx("span", { className: "tw-sr-only", children: "Close" })
] }) }), g = o.forwardRef(({
  className: t,
  ...e
}, s) => /* @__PURE__ */ a.jsx(p, { ref: s, className: l("tw-fixed tw-inset-0 tw-z-[9997] tw-bg-gray-900/80 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0", t), ...e }));
g.displayName = p.displayName;
const T = c("tw-p-0 tw-gap-0 tw-min-w-full tw-flex tw-flex-col", {
  variants: {
    size: {
      sm: "sm:tw-min-w-[400px] tw-min-w-[280px] tw-w-[initial] tw-max-h-[90vh]",
      md: "md:tw-min-w-[600px] md:tw-max-h-[90vh] max-md:tw-top-[32px] max-md:tw-bottom-0 max-md:tw-translate-y-[0%] max-md:tw-max-h-[calc(100vh-32px)] max-md:tw-bottom-0 max-md:tw-translate-y-[0%] max-md:tw-top-[unset]",
      lg: "lg:tw-min-w-[800px] tw-max-h-[90vh] max-lg:tw-max-h-[calc(100vh-32px)] max-lg:tw-bottom-0 max-lg:tw-translate-y-[0%] max-lg:tw-top-[unset]",
      full: "tw-min-w-full tw-min-h-screen tw-h-screen"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), B = o.forwardRef(({
  className: t,
  children: e,
  size: s,
  overlayClassName: w,
  testId: r,
  ...i
}, n) => /* @__PURE__ */ a.jsxs(C, { children: [
  /* @__PURE__ */ a.jsx(g, { className: w }),
  /* @__PURE__ */ a.jsx(y.Provider, { value: {
    size: s
  }, children: /* @__PURE__ */ a.jsx(x, { ref: n, "data-testid": r, className: l("tw-fixed tw-left-[50%] tw-top-[50%] tw-z-[9998] tw-w-full tw-max-w-lg tw-translate-x-[-50%] tw-translate-y-[-50%] tw-gap-16 tw-bg-base-white tw-p-24 tw-shadow-lg tw-duration-200 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[state=closed]:tw-slide-out-to-left-1/2 data-[state=closed]:tw-slide-out-to-top-[48%] data-[state=open]:tw-slide-in-from-left-1/2 data-[state=open]:tw-slide-in-from-top-[48%] tw-rounded-4 tw-flex tw-flex-col tw-overflow-auto", T({
    size: s
  }), t), ...i, children: e }) })
] }));
B.displayName = x.displayName;
const k = c("sm:tw-p-32 tw-p-24 tw-relative tw-space-y-0", {
  variants: {
    headerAlignment: {
      center: "tw-flex tw-items-start tw-justify-center",
      left: "tw-flex tw-items-start"
    }
  },
  defaultVariants: {
    headerAlignment: "left"
  }
}), K = ({
  className: t,
  children: e,
  showCloseButton: s,
  headerAlignment: w,
  image: r,
  ...i
}) => /* @__PURE__ */ a.jsxs("div", { className: l("tw-flex tw-relative", k({
  headerAlignment: w
}), t), ...i, children: [
  /* @__PURE__ */ a.jsxs("div", { className: l("tw-flex tw-items-start tw-gap-12 tw-flex-1", {
    "tw-justify-start": w !== "center",
    "tw-justify-center tw-flex-col tw-items-center tw-text-center": w === "center"
  }), children: [
    r && o.isValidElement(r) && /* @__PURE__ */ a.jsx("div", { className: l("tw-flex-shrink-0", {
      "tw-max-w-24 tw-max-h-24 tw-mt-[3px]": w !== "center",
      "tw-max-w-48 tw-max-h-48": w === "center"
    }), children: r }),
    /* @__PURE__ */ a.jsx("div", { className: "tw-w-full", children: e })
  ] }),
  s && /* @__PURE__ */ a.jsx(R, { headerAlignment: w })
] }), z = ({
  className: t,
  showScrollBorder: e,
  children: s,
  ...w
}) => {
  const [r, i] = o.useState(!1), n = o.useRef(null), m = o.useCallback(() => {
    if (!n.current) return;
    const d = n.current.scrollTop;
    i(d > 0);
  }, []);
  return o.useEffect(() => {
    const d = n.current;
    if (d)
      return d.addEventListener("scroll", m), () => d.removeEventListener("scroll", m);
  }, [m]), /* @__PURE__ */ a.jsx("div", { ref: n, className: l("tw-flex-1 tw-overflow-auto sm:tw-px-32 tw-px-24 tw-overflow-y-auto", {
    "tw-border-b tw-border-gray-300": e,
    "tw-border-t tw-border-gray-300": e && r
  }, t), ...w, children: s });
};
z.displayName = "DialogBody";
const E = ({
  className: t,
  children: e,
  ...s
}) => {
  const {
    size: w
  } = o.useContext(y);
  return /* @__PURE__ */ a.jsx("div", { className: l("tw-flex tw-flex-col-reverse sm:tw-flex-row sm:tw-justify-end md:tw-space-x-8", {
    "tw-px-24 tw-py-16": w === "sm",
    "tw-px-32 tw-py-24": w !== "sm"
  }, t), ...s, children: e });
};
E.displayName = "DialogFooter";
const S = o.forwardRef(({
  className: t,
  ...e
}, s) => /* @__PURE__ */ a.jsx(u, { ref: s, className: l("tw-headline-3-m tw-text-gray-900 sm:tw-headline-4-m", t), ...e }));
S.displayName = u.displayName;
const F = o.forwardRef(({
  className: t,
  ...e
}, s) => /* @__PURE__ */ a.jsx(f, { ref: s, className: l("tw-body-2 tw-text-gray-600 tw-mt-2", t), ...e }));
F.displayName = f.displayName;
const P = c("tw-flex tw-w-full sm:tw-px-32 tw-px-24 tw-py-8 tw-items-center tw-justify-center", {
  variants: {
    variant: {
      green: "tw-bg-green-800 tw-text-brand-white",
      red: "tw-bg-red-800 tw-text-brand-white",
      black: "tw-bg-brand-black tw-text-brand-white",
      gray: "tw-bg-gray-200",
      yellow: "tw-bg-yellow-200 tw-text-yellow-900",
      white: "tw-bg-base-white tw-text-brand-black"
    }
  },
  defaultVariants: {
    variant: "gray"
  }
}), V = o.forwardRef(({
  variant: t,
  children: e
}, s) => /* @__PURE__ */ a.jsx("div", { ref: s, className: P({
  variant: t
}), children: e }));
V.displayName = "DialogBanner";
export {
  I as D,
  V as a,
  z as b,
  R as c,
  B as d,
  F as e,
  E as f,
  K as g,
  g as h,
  C as i,
  S as j,
  J as k
};
//# sourceMappingURL=Dialog.CH2ZNDp8.js.map
